module.exports = __webpack_public_path__ + "static/media/pointer.dc4ae56f.svg";